import { useBCMSContext, useParams, BCMSRecord } from "@bcm-dev/bcms-vite";
import Classes, { Card } from "model";
import WidgetContainer, { WidgetNavItem } from "components/shared/containers/WidgetContainer";

export default function SettingsNavWidget(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const defaultCard = controller.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
    let cardID = useParams().cardID ?? defaultCard;
    const creditCardOptionOn = controller.state.branding.options.include_credit_chw23 !== "false";
  
    if(!creditCardOptionOn && cardID === "1") {
      cardID = "0";
    }
    const card = Card.initByID(cardID);

    const shouldDisable = card.active === false || card.recentlyAdded === true;
    const settingsRoute = !shouldDisable ? "/settings" : "";

    return (
        <WidgetContainer className="settings-nav-item">
            <WidgetNavItem text="Settings" icon="GearIcon" dataPoint="Settings_Link"  route={ settingsRoute }/>
        </WidgetContainer>
    );
}